import { NgModule } from '@angular/core';
import { NotificationRoutingModule } from './notification-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FunctionsService } from '../../services/functions.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSortModule } from '@angular/material/sort';
import { NgxPermissionsModule } from 'ngx-permissions';
import { NotificationComponent } from './notification.component';
import { ApproveNotificationComponent } from './approve-notification/approve-notification.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ViewNotificationComponent } from './view-notification/view-notification.component';
import { EditNotificationComponent } from './edit-notification/edit-notification.component';
import { AuthInterceptorProvider } from 'src/app/services/token/token-interceptor.service';

@NgModule({
    declarations: [
        ApproveNotificationComponent,
        EditNotificationComponent,
        NotificationComponent,
        ViewNotificationComponent
    ],
    imports: [
        NotificationRoutingModule,
        BreadcrumbModule,
        CommonModule,
        FormsModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatInputModule,
        MatNativeDateModule,
        MatTableModule,
        MatTabsModule,
        MatPaginatorModule,
        MatProgressSpinnerModule,
        MatSortModule,
        NgbModule,
        NgMultiSelectDropDownModule,
        NgxPermissionsModule,
        NgxSpinnerModule,
        ReactiveFormsModule,
        TranslateModule
    ],
    providers: [FunctionsService, AuthInterceptorProvider]
})
export class NotificationModule {}